var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "clipboard-item-card group",
      class: {
        "clipboard-item-card--clickable":
          !_vm.inlineEditing && (_vm.isNote || _vm.insertOnly),
        "clipboard-item-card--editing": _vm.inlineEditing,
      },
      on: { click: _vm.onCardClick },
    },
    [
      _vm.inlineEditing
        ? [
            _c(
              "div",
              { staticClass: "clipboard-item-card__head" },
              [
                _c("ClipboardTypeIcon", {
                  staticClass: "clipboard-item-card__type-icon",
                  attrs: { type: _vm.item.type },
                }),
                _vm._v(" "),
                _c("span", { staticClass: "clipboard-item-card__type" }, [
                  _vm._v(_vm._s(_vm.typeLabel)),
                ]),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass: "clipboard-item-card__sep",
                    attrs: { "aria-hidden": "true" },
                  },
                  [_vm._v("·")]
                ),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.editTitle,
                      expression: "editTitle",
                    },
                  ],
                  staticClass: "clipboard-item-card__title-input",
                  attrs: { type: "text", placeholder: _vm.titlePlaceholder },
                  domProps: { value: _vm.editTitle },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                    },
                    keydown: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      $event.preventDefault()
                      return _vm.onSaveEdit.apply(null, arguments)
                    },
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.editTitle = $event.target.value
                    },
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.editContent,
                  expression: "editContent",
                },
              ],
              staticClass: "clipboard-item-card__content-input",
              class: {
                "clipboard-item-card__content-input--mono": _vm.monoBody,
              },
              attrs: { rows: "4" },
              domProps: { value: _vm.editContent },
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                },
                keydown: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  if (
                    $event.ctrlKey ||
                    $event.shiftKey ||
                    $event.altKey ||
                    $event.metaKey
                  )
                    return null
                  $event.preventDefault()
                  return _vm.onSaveEdit.apply(null, arguments)
                },
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.editContent = $event.target.value
                },
              },
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "clipboard-item-card__edit-actions",
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                  },
                },
              },
              [
                _c(
                  "button",
                  {
                    staticClass:
                      "clipboard-item-card__edit-btn clipboard-item-card__edit-btn--ghost",
                    attrs: { type: "button", disabled: _vm.saving },
                    on: {
                      mousedown: function ($event) {
                        $event.stopPropagation()
                      },
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.$emit("cancel-edit")
                      },
                    },
                  },
                  [
                    _c(
                      "svg",
                      {
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "12",
                          height: "12",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "aria-hidden": "true",
                        },
                      },
                      [
                        _c("path", { attrs: { d: "M18 6 6 18" } }),
                        _vm._v(" "),
                        _c("path", { attrs: { d: "m6 6 12 12" } }),
                      ]
                    ),
                    _vm._v("\n        Cancel\n      "),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass:
                      "clipboard-item-card__edit-btn clipboard-item-card__edit-btn--primary",
                    attrs: {
                      type: "button",
                      disabled: !_vm.canSaveEdit || _vm.saving,
                    },
                    on: {
                      mousedown: function ($event) {
                        $event.stopPropagation()
                      },
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.onSaveEdit.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _c(
                      "svg",
                      {
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "12",
                          height: "12",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "aria-hidden": "true",
                        },
                      },
                      [_c("path", { attrs: { d: "M20 6 9 17l-5-5" } })]
                    ),
                    _vm._v("\n        Save\n      "),
                  ]
                ),
              ]
            ),
          ]
        : [
            _c(
              "div",
              { staticClass: "clipboard-item-card__head" },
              [
                _c("ClipboardTypeIcon", {
                  staticClass: "clipboard-item-card__type-icon",
                  attrs: { type: _vm.item.type },
                }),
                _vm._v(" "),
                _c("span", { staticClass: "clipboard-item-card__type" }, [
                  _vm._v(_vm._s(_vm.typeLabel)),
                ]),
                _vm._v(" "),
                _vm.showTitle
                  ? [
                      _c(
                        "span",
                        {
                          staticClass: "clipboard-item-card__sep",
                          attrs: { "aria-hidden": "true" },
                        },
                        [_vm._v("·")]
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        { staticClass: "clipboard-item-card__title" },
                        [_vm._v(_vm._s(_vm.item.title))]
                      ),
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "clipboard-item-card__right" }, [
                  _c("span", { staticClass: "clipboard-item-card__date" }, [
                    _vm._v(_vm._s(_vm.savedAtLabel)),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "clipboard-item-card__hover-actions",
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                        },
                      },
                    },
                    [
                      _vm.canInlineEdit
                        ? _c(
                            "button",
                            {
                              staticClass: "clipboard-item-card__edit-icon",
                              attrs: {
                                type: "button",
                                "aria-label": "Edit",
                                title: "Edit",
                              },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.$emit("edit", _vm.item)
                                },
                              },
                            },
                            [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    width: "12",
                                    height: "12",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: "currentColor",
                                    "stroke-width": "2",
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                    "aria-hidden": "true",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d: "M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("path", { attrs: { d: "m15 5 4 4" } }),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "clipboard-item-card__actions" },
                        [
                          _vm.amazonUrl
                            ? _c(
                                "a",
                                {
                                  staticClass: "clipboard-item-card__action",
                                  attrs: {
                                    href: _vm.amazonUrl,
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    title: "Open on Amazon",
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "svg",
                                    {
                                      attrs: {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        width: "14",
                                        height: "14",
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        stroke: "currentColor",
                                        "stroke-width": "2",
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                        "aria-hidden": "true",
                                      },
                                    },
                                    [
                                      _c("path", { attrs: { d: "M15 3h6v6" } }),
                                      _vm._v(" "),
                                      _c("path", {
                                        attrs: { d: "M10 14 21 3" },
                                      }),
                                      _vm._v(" "),
                                      _c("path", {
                                        attrs: {
                                          d: "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6",
                                        },
                                      }),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.insertOnly
                            ? _c(
                                "button",
                                {
                                  staticClass: "clipboard-item-card__action",
                                  attrs: {
                                    type: "button",
                                    title: "Insert into chat",
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.$emit("insert", _vm.item)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "svg",
                                    {
                                      attrs: {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        width: "14",
                                        height: "14",
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        stroke: "currentColor",
                                        "stroke-width": "2",
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                        "aria-hidden": "true",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        attrs: {
                                          d: "M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11z",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("path", {
                                        attrs: {
                                          d: "m21.854 2.147-10.94 10.939",
                                        },
                                      }),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "clipboard-item-card__action",
                              attrs: { type: "button", title: "Copy" },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.$emit("copy", _vm.item)
                                },
                              },
                            },
                            [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    width: "14",
                                    height: "14",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: "currentColor",
                                    "stroke-width": "2",
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                    "aria-hidden": "true",
                                  },
                                },
                                [
                                  _c("rect", {
                                    attrs: {
                                      width: "14",
                                      height: "14",
                                      x: "8",
                                      y: "8",
                                      rx: "2",
                                      ry: "2",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("path", {
                                    attrs: {
                                      d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass:
                                "clipboard-item-card__action clipboard-item-card__action--danger",
                              attrs: {
                                type: "button",
                                title: "Delete",
                                disabled: _vm.deleting,
                              },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.$emit("delete", _vm.item)
                                },
                              },
                            },
                            [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    width: "14",
                                    height: "14",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: "currentColor",
                                    "stroke-width": "2",
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                    "aria-hidden": "true",
                                  },
                                },
                                [
                                  _c("path", { attrs: { d: "M3 6h18" } }),
                                  _vm._v(" "),
                                  _c("path", {
                                    attrs: {
                                      d: "M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("path", {
                                    attrs: {
                                      d: "M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("line", {
                                    attrs: {
                                      x1: "10",
                                      x2: "10",
                                      y1: "11",
                                      y2: "17",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("line", {
                                    attrs: {
                                      x1: "14",
                                      x2: "14",
                                      y1: "11",
                                      y2: "17",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                ]),
              ],
              2
            ),
            _vm._v(" "),
            _vm.isNote
              ? _c("p", {
                  staticClass:
                    "clipboard-item-card__content clipboard-item-card__content--note",
                  class: {
                    "clipboard-item-card__content--expanded": _vm.expanded,
                  },
                  domProps: { innerHTML: _vm._s(_vm.noteHtml) },
                })
              : _c(
                  "p",
                  {
                    staticClass: "clipboard-item-card__content",
                    class: {
                      "clipboard-item-card__content--mono": _vm.monoBody,
                    },
                  },
                  [_vm._v("\n      " + _vm._s(_vm.displayContent) + "\n    ")]
                ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }